/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-plusplus */
/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, {
  useState, useMemo, useRef, useEffect,
} from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import DraggableContent from './DraggableContent';
import { setExpandedItem, removeExpandedItem, clearMostRecentlyAddedCalendarItemTracker } from '../../ducks/calendarActions';
import { flushDebounceForTable } from './hooks/debounceHandler';
import useCalendarDnDMapping from './hooks/useCalendarDnDMapping';

const DraggableDiv = styled('div')`
  border-radius: ${(props) => (props.isDragging || props.isHovered ? '4px' : 'none')};
  border: ${(props) => (props.isDragging || (props.isHovered && !props.disableBlueBorder) ? '1px dashed #77A7FF' : 'white')};
  box-shadow: ${(props) => (props.isDragging ? `${BoxShadow}` : 'none')};
  background: ${(props) => props.customBackground || 'white'};
  transition: none;
  margin-top: ${(props) => (props.addMarginTop && !props.isSessionBreak ? '3px' : props.addMarginTop && props.isSessionBreak ? '8px' : null)};
  margin-bottom: ${(props) => props.addMarginBottom && '3px'};
`;

const DraggableDivWrapper = ({
  cache,
  isWeekView,
  isDayExpanded,
  date,
  dayNumber,
  item,
  index,
  id,
  measure,
  onDayExpand,
}) => {
  const contentRef = useRef(null);
  const selectedItem = useSelector((state) => (state.calendar.data.selectedItems[item.assignedId]));
  const dispatch = useDispatch();
  const [hoveredId, setHoveredId] = useState(null);
  const [localAdditionalInfo, setLocalAdditionalInfo] = useState('');
  const [localDescription, setLocalDescription] = useState('');
  const expandedItem = useSelector((state) => state.calendar.data.expandedItems[item.assignedId]);
  const mostRecentlyAddedCalendarItem = useSelector((state) => state.calendar.data.mostRecentlyAddedCalendarItem);
  const expandedItems = useSelector((state) => state.calendar.data.expandedItems);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const effectiveSelectedProgramDayNumber = dayNumber || selectedProgramDayNumber;
  const dateObj = new Date(effectiveDate);
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');
  const programType = useSelector((state) => state.calendar.data.programType);
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      effectiveSelectedProgramDayNumber
    ]?.exercises || []) : useSelector((state) => state.calendar.data.calendarItems[endpointFormattedDate]?.exercises || []);

  const {
    shouldCollapseItemBelongingToSessionBreak,
    getItemsUnderSessionBreak,
  } = useCalendarDnDMapping(calendarItems, expandedItems);

  const isCalendarOptionsDropdownMenuOpen = useSelector((state) => state.calendar.data.isCalendarOptionsDropdownMenuOpen);
  const isStaticAddColumnDropdownMenuopen = useSelector((state) => state.calendar.data.isStaticAddColumnDropdownMenuOpen);
  const draggedItem = useSelector((state) => state.calendar.data.draggedItem);

  const doesGroupingLetterAboveItemMatchContent = !!item.groupingLetter
  && item.groupingLetter === calendarItems[index - 1]?.groupingLetter;

  const doesGroupingLetterBelowItemMatchContent = !!item.groupingLetter
  && item.groupingLetter === calendarItems[index + 1]?.groupingLetter;

  const isCurrentItemBelowASessionBreak = (currentItemId) => {
    const currentIndex = calendarItems.findIndex(
      (calendarItem) => calendarItem.assignedId === currentItemId,
    );
    if (currentIndex === -1) return false;

    /** Return false if the current item itself is a session break */
    if (calendarItems[currentIndex]?.type === 'session_break') return false;

    /** Check if any earlier item is a session break */
    return calendarItems
      .slice(0, currentIndex) /** only look at items before the current one */
      .some((itemInCalendar) => itemInCalendar.type === 'session_break');
  };

  useEffect(() => {
    /** Only run when there is a recently added calendar item && when calendarItems.length exists &&
     * when the item is a session break
     *  and when the most recently added item exists underneath the session break */
    if (mostRecentlyAddedCalendarItem && calendarItems?.length && item?.type === 'session_break' && getItemsUnderSessionBreak(item)?.[mostRecentlyAddedCalendarItem?.assignedId]) {
      dispatch(setExpandedItem(item));
      dispatch(clearMostRecentlyAddedCalendarItemTracker());
    }
  }, [mostRecentlyAddedCalendarItem]);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true; /** skip first run because cell measurer wrapper will get that and we don't want to run it twice */
      return;
    }

    if (measure) {
      /** we need to clear the cache because we have to account
       * for session break items and hidden items, there are alot of
       * instances where we need the cache to clear so we can update the layout and don't
       * retain the layout from the old heights
       */
      cache.clearAll();
      measure();
    }
  }, [
    measure,
    expandedItem,
    shouldCollapseItemBelongingToSessionBreak(item, draggedItem),
    localAdditionalInfo,
    localDescription,
  ]);

  const handleClick = () => {
    if (expandedItem) {
      dispatch(removeExpandedItem(item));
    } else {
      dispatch(setExpandedItem(item));
    }
  };

  const typeDoesNotExpand = (typeItem) => {
    if (
      typeItem.type === 'warm_up'
      || typeItem.type === 'W'
      || typeItem.type === 'health'
      || typeItem.type === 'H'
      || typeItem.type === 'note'
      || typeItem.type === 'N'
      || typeItem.type === 'cooldown'
      || typeItem.type === 'CD'
    ) {
      return true;
    }
    return false;
  };

  const handleIsCheckBoxForTypeVisible = (checkBoxItem) => {
    /** if hovered or check box is selected the checkbox should always be visible */
    if (hoveredId === `${checkBoxItem.assignedId}-programmedCalendarItems` || selectedItem) {
      return true;
    }
    return false;
  };

  const handleMouseLeave = () => {
    setHoveredId(null);
    flushDebounceForTable(item.assignedId);
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      const isInsideContainer = contentRef.current?.contains(e.target);

      if (isCalendarOptionsDropdownMenuOpen || isStaticAddColumnDropdownMenuopen) return;

      if (!isInsideContainer) {
        flushDebounceForTable(item.assignedId);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isCalendarOptionsDropdownMenuOpen, isStaticAddColumnDropdownMenuopen]);

  return (
    <Draggable key={item.assignedId} draggableId={`${item.assignedId}-programmedCalendarItems`} index={index}>
      {(draggableProvided, snapshot) => {
        const itemHoveredOverId = snapshot?.combineTargetFor?.split('-programmedCalendarItems')[0];
        const itemHoveringOver = calendarItems?.find((calendarItem) => calendarItem?.assignedId?.toString() === itemHoveredOverId);
        const itemIdStr = `${item.assignedId}-programmedCalendarItems`;

        const computedStyle = useMemo(() => ({
          ...(draggableProvided.draggableProps.style),
          opacity: shouldCollapseItemBelongingToSessionBreak(item, draggedItem) ? 0 : 1,
        }), [id, draggableProvided.draggableProps.style, shouldCollapseItemBelongingToSessionBreak(item, draggedItem)]);

        const shouldHighlight = (
          (hoveredId === itemIdStr && !expandedItem && !item.preSave)
          || (hoveredId === itemIdStr && typeDoesNotExpand(item))
          || selectedItem
        );

        const computedBackground = shouldHighlight ? 'rgba(252, 252, 252, 1)' : (item.type === 'session_break' || isCurrentItemBelowASessionBreak(item?.assignedId)) ? '#F8F8F8' : 'white';

        const setRefs = (node) => {
          contentRef.current = node;
          draggableProvided.innerRef(node);
        };

        return (
          <DraggableDiv
            onMouseEnter={() => {
              setHoveredId(itemIdStr);
            }}
            onMouseLeave={handleMouseLeave}
            ref={setRefs}
            {...draggableProvided.draggableProps}
            {...draggableProvided.dragHandleProps}
            isDragging={snapshot.isDragging}
            style={computedStyle}
            customBackground={computedBackground}
            isHovered={snapshot.combineTargetFor != null}
            disableBlueBorder={item.type === 'session_break' || itemHoveringOver?.type === 'session_break' || item?.type === 'questionnaire' || itemHoveringOver?.type === 'questionnaire'}
            addMarginTop={!doesGroupingLetterAboveItemMatchContent && index !== 0 && !isCurrentItemBelowASessionBreak(item?.assignedId)}
            isSessionBreak={item.type === 'session_break'}
            addMarginBottom={!doesGroupingLetterBelowItemMatchContent && item.type !== 'session_break' && !isCurrentItemBelowASessionBreak(item?.assignedId)}
            shouldCollapseItemBelongingToSessionBreak={shouldCollapseItemBelongingToSessionBreak(item, draggedItem)}
            isWeekView={isWeekView}
          >
            <>
              {shouldCollapseItemBelongingToSessionBreak(item, draggedItem) ? null : (
                <DraggableContent
                  localDescription={localDescription}
                  setLocalDescription={setLocalDescription}
                  localAdditionalInfo={localAdditionalInfo}
                  setLocalAdditionalInfo={setLocalAdditionalInfo}
                  measure={measure}
                  isHovered={snapshot.combineTargetFor != null}
                  itemHoveringOverCurrentItem={itemHoveringOver}
                  itemIsHoveredByMouse={hoveredId === itemIdStr}
                  isDragging={snapshot.isDragging}
                  content={item}
                  index={index}
                  shouldShowQuickActions={shouldHighlight}
                  isExpanded={!!expandedItem}
                  setIsExpanded={() => handleClick(item.assignedId)}
                  isDayExpanded={isDayExpanded}
                  date={effectiveDate}
                  dayNumber={effectiveSelectedProgramDayNumber}
                  checkboxVisible={
                  typeDoesNotExpand(item)
                    ? handleIsCheckBoxForTypeVisible(item)
                    : (hoveredId === itemIdStr || selectedItem || !!expandedItem) || item.preSave
                  }
                  isWeekView={isWeekView}
                  onDayExpand={onDayExpand}
                />
              )}
            </>
          </DraggableDiv>
        );
      }}
    </Draggable>
  );
};

export default DraggableDivWrapper;
